module.exports = __webpack_public_path__ + "img/SBS_common.cf2d07c6.png";